import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, Table, TableHead, TableCell, TableBody, TableRow, ButtonBase, IconButton, Collapse, } from '@material-ui/core';


import Apis from '../../../network/Apis';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import BasketTextItem from './BasketTextItem';


class MovieStateBasketTextLive extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: 0,
            value: 1,
            tlive: [],
            opens: [],
            liveData: null,
        };
        console.log('MovieStateBasketTextLive', props);
    }

    componentDidMount() {
        this.getBasketballRealtimeData();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getBasketballRealtimeData = async () => {
        let { matchId, matchType } = this.props.match.params;
        const { data } = this.props;
        if (matchType == 0 && data) {
            matchType = data.match_type;
        }
        if (matchId == 0 && data) {
            matchId = data.match_id;
        }

        let result = await Apis.encryptionDetailLive(matchType, matchId);
        console.log('MovieStateBasketTextLive', result);
        if (result.code == 200) {
            let data = [];
            if (result.data && result.data.tlive) {
                for (let i = 0; i < result.data.tlive.length; i++) {
                    let lives = [];
                    if (result.data.tlive[i]) {
                        lives = result.data.tlive[i].reverse();
                    }
                    let title = '第' + (i + 1) + '节';
                    if (i >= 4) {
                        title = '加时';
                    }
                    let obj = {
                        title: title,
                        live: lives,
                        open: i == result.data.tlive.length - 1,
                    }
                    data.push(obj);
                }
            }
            let ttdata = data.reverse();
            this.setState({ tlive: result.data.tlive, liveData: ttdata });
        }
    }


    _setOpen = (open) => {
        console.log('_setOpen', open);
        if (this.state.liveData[open]) {
            this.state.liveData[open].open = !this.state.liveData[open].open;
        }
        this.setState({ liveData: this.state.liveData });
    }

    getItemsData(item, idx) {
        if (item) {
            let items = item.split('^');
            if (items[idx]) {
                return items[idx];
            }
        }
        return '';
    }

    getTeamName(item, idx) {
        let postion = this.getItemsData(item, idx);
        let { data } = this.props.location;
        if (postion == 1) {
            if (data) {
                return data.home_name;
            }
        } else if (postion == 2) {
            if (data) {
                return data.away_name;
            }
        }
        return '';
    }

    renderCollapse(open, data) {

        return (
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Grid container direction='column'>
                    <Grid container direction='column'>
                        {
                            data.map((item, i) => (
                                <Grid key={i}>
                                    <BasketTextItem
                                        time={this.getItemsData(item, 1)}
                                        title={this.getItemsData(item, 5)}
                                        teamName={this.getTeamName(item, 2)}
                                        score={this.getItemsData(item, 4)}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
            </Collapse>
        );
    }

    render() {
        const { classes } = this.props;
        const { liveData } = this.state;

        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.root}>
                <Grid container direction='column' alignItems='center' justifyContent='center'>
                    {
                        liveData && <Grid container direction='column'>
                            <Grid container direction='column'>
                                {
                                    liveData.map((item, i) => (
                                        <Grid key={i} container direction='column'>
                                            <Grid container direction='row' justifyContent='space-between' alignItems='center' style={{ marginTop: 8, marginBottom: 8 }}>
                                                <Typography style={{ fontSize: 14, color: '#0D0D0D', maxWidth: '30vw', flex: 1, marginLeft: 16 }}>{item.title}</Typography>
                                                <Grid container direction='row' justifyContent='flex-end' style={{ maxWidth: '30vw' }}>
                                                    <IconButton className={classes.iconButton} style={{}} onClick={() => this._setOpen(i)}>
                                                        {
                                                            item.open ? <ExpandLess style={{ fontSize: 16, color: '#898989' }} /> : <ExpandMore style={{ fontSize: 16, color: '#898989' }} />
                                                        }
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                            <Grid style={{ backgroundColor: '#F5F5F5', height: 1, width: '100%' }} />
                                            {
                                                item.open && <Grid container direction='column'>
                                                    {
                                                        this.renderCollapse(item.open, item.live)
                                                    }
                                                </Grid>
                                            }
                                        </Grid>
                                    ))
                                }

                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        borderRadius: 10,
        backgroundColor: '#FFF'
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 2, 0, 0),
    }

}))(MovieStateBasketTextLive));